export default (theme) => {
  return {
    avatar: {
      marginRight: theme.spacing(),
    },
  }
}
